(function () {
  if (window.tokboltCartAddonBound) return;

  window.tokboltCartAddonBound = true;

  function getFetchConfig() {
    if (typeof fetchConfig === 'function') {
      var config = fetchConfig('javascript');
      config.headers['Content-Type'] = 'application/json';
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      return config;
    }

    return {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    };
  }

  function getMainCartSections() {
    var sections = [];
    var mainItems = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var wrapper = document.getElementById('main-cart-items-wrapper');
    var shipping = document.getElementById('main-cart-shipping');

    if (mainItems) {
      sections.push({
        id: 'main-cart-items',
        section: mainItems.dataset.id,
        selector: '.js-contents',
      });
    }

    sections.push({
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section',
    });

    sections.push({
      id: 'cart-live-region-text',
      section: 'cart-live-region-text',
      selector: '.shopify-section',
    });

    if (footer) {
      sections.push({
        id: 'main-cart-footer',
        section: footer.dataset.id,
        selector: '.js-contents-totals',
      });
    }

    if (wrapper) {
      sections.push({
        id: 'main-cart-items-wrapper',
        section: wrapper.dataset.id,
        selector: '.js-cart-count',
      });
    }

    if (shipping) {
      sections.push({
        id: 'main-cart-shipping',
        section: shipping.dataset.id,
        selector: '.js-contents-shipping',
      });
    }

    return sections.filter(function (section) {
      return section.section;
    });
  }

  function getSectionInnerHTML(html, selector) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var node = parsed.querySelector(selector);

    return node ? node.innerHTML : '';
  }

  function renderMainCart(response) {
    var sections = getMainCartSections();

    sections.forEach(function (section) {
      var container = document.getElementById(section.id);
      var html = response.sections ? response.sections[section.section] : '';

      if (!container || !html) return;

      var target = container.querySelector(section.selector) || container;
      var replacement = getSectionInnerHTML(html, section.selector);

      if (target && replacement) {
        target.innerHTML = replacement;
      }
    });

    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tokbolt-cart-addon' });
    }
  }

  function setButtonState(button, loading) {
    var label = button.querySelector('[data-tokbolt-cart-addon-label]');
    var defaultText = button.dataset.buttonText || 'Add to cart';

    button.disabled = loading;
    button.setAttribute('aria-busy', loading ? 'true' : 'false');

    if (label) {
      label.textContent = loading ? 'Adding...' : defaultText;
    }
  }

  function setError(root, message) {
    var error = root ? root.querySelector('[data-tokbolt-cart-addon-error]') : null;

    if (error) {
      error.textContent = message || '';
    }
  }

  function addAddon(button) {
    var variantId = Number(button.dataset.variantId || 0);
    var root = button.closest('.tokbolt-cart-addon');
    var drawer = document.querySelector('cart-drawer');
    var useDrawerRender = !!button.closest('cart-drawer') && drawer;
    var payload = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };
    var config = getFetchConfig();

    if (!variantId || button.disabled) return;

    setButtonState(button, true);
    setError(root, '');

    if (useDrawerRender && typeof drawer.getSectionsToRender === 'function') {
      payload.sections = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
      payload.sections_url = window.location.pathname;
    } else {
      payload.sections = getMainCartSections().map(function (section) {
        return section.section;
      });
      payload.sections_url = window.location.pathname;
    }

    config.body = JSON.stringify(payload);

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || window.cartStrings.error);
        }

        if (
          useDrawerRender &&
          typeof drawer.renderContents === 'function' &&
          response.sections
        ) {
          drawer.renderContents(response);
        } else if (response.sections) {
          renderMainCart(response);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function (error) {
        setError(root, error.message || window.cartStrings.error);
      })
      .finally(function () {
        if (document.body.contains(button)) {
          setButtonState(button, false);
        }
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-tokbolt-cart-addon-add]');

    if (!button) return;

    event.preventDefault();
    addAddon(button);
  });
})();
